import { Routes } from "@angular/router";
import { AuthGuard } from "@auth0/auth0-angular";
import { profileGuard } from "./core/guards/profile.guard";
import { firstTimeGuard } from "./core/guards/first-time.guard";
import { rootGuard } from "./core/guards/root.guard";

export const routes: Routes = [
  {
    path: "verify-email",
    loadComponent: () => import("./pages/verify-email/verify-email.component").then((m) => m.VerifyEmailComponent),
    canActivate: [AuthGuard, firstTimeGuard],
  },
  {
    path: "verification-sent",
    loadComponent: () => import("./pages/verification-sent/verification-sent.component").then((m) => m.VerificationSentComponent),
    canActivate: [AuthGuard, firstTimeGuard],
  },
  {
    path: "signup",
    loadComponent: () => import("./pages/signup/signup.component").then((m) => m.SignupComponent),
  },
  {
    path: "callback",
    loadComponent: () => import("./pages/callback/callback.component").then((m) => m.CallbackComponent),
  },
  {
    path: "onboarding",
    loadComponent: () => import("./pages/onboarding/onboarding.component").then((m) => m.OnboardingComponent),
    canActivate: [AuthGuard, firstTimeGuard],
  },
  {
    path: "welcome",
    loadComponent: () => import("./pages/welcome/welcome.component").then((m) => m.WelcomeComponent),
    canActivate: [AuthGuard, firstTimeGuard],
  },
  {
    path: "pay/:invoiceId/:paymentMethodName",
    loadComponent: () => import("./pages/payments/pages/payment-processing/payment-processing.component").then((m) => m.PaymentProcessingComponent),
  },
  {
    path: "pay/:invoiceId",
    loadComponent: () => import("./pages/direct-pay/direct-pay.component").then((m) => m.DirectPayComponent),
  },
  {
    path: "main",
    loadComponent: () => import("./layouts/main-layout/main-layout.component").then((m) => m.MainLayoutComponent),
    children: [
      {
        path: "projects",
        loadComponent: () => import("./pages/projects/projects.component").then((m) => m.ProjectsComponent),
      },
      {
        path: "projects/:projectId",
        loadComponent: () => import("./pages/projects/case/project-details-shell/project-details-shell.component").then((m) => m.ProjectDetailsShellComponent),
      },
      {
        path: "projects/:projectId/milestones/:milestoneId",
        loadComponent: () => import("./pages/projects/case/project-milestone-details-shell/project-milestone-details-shell.component").then((m) => m.ProjectMilestoneDetailsShellComponent),
      },
      {
        path: "projects/:projectId/disputes",
        loadComponent: () => import("./pages/disputes/disputes.component").then((m) => m.DisputesComponent),
      },
      {
        path: "chats",
        loadComponent: () => import("./pages/chats/chats.component").then((m) => m.ChatsComponent),
      },
      {
        path: "chats/:conversationId",
        loadComponent: () => import("./pages/chats/pages/chat-detail/chat-detail.component").then((m) => m.ChatDetailComponent),
      },
      {
        path: "funding",
        loadComponent: () => import("./pages/funding/funding.component").then((m) => m.FundingComponent),
      },
      {
        path: "payments",
        redirectTo: "funding",
        pathMatch: "full",
      },
      {
        path: "payments/:invoiceId/:paymentMethodName",
        loadComponent: () => import("./pages/payments/pages/payment-processing/payment-processing.component").then((m) => m.PaymentProcessingComponent),
      },
      {
        path: "payments/:invoiceId",
        loadComponent: () => import("./pages/payments/case/payment-details-shell/payment-details-shell.component").then((m) => m.PaymentDetailsShellComponent),
      },
      {
        path: "settings",
        loadComponent: () => import("./pages/settings/settings.component").then((m) => m.SettingsComponent),
      },
      {
        path: "",
        redirectTo: "projects",
        pathMatch: "full",
      },
    ],
    canActivate: [AuthGuard, profileGuard],
  },
  {
    path: "",
    loadComponent: () => import("./pages/landing-page/landing-page.component").then((m) => m.LandingPageComponent),
    canActivate: [rootGuard],
  },
  { path: "**", redirectTo: "" },
];
